import { routing } from "@/i18n/routing"

/**
 * Get the home page href for a given locale
 * @param locale - The locale string (e.g., "vi", "en", "cs")
 * @returns The href path for the home page of that locale
 */
export function getLocaleHomeHref(locale: string): string {
  // If locale is the default locale, return "/"
  // Otherwise, return "/{locale}"
  return locale === routing.defaultLocale ? "/" : `/${locale}`
}

/**
 * Prefix a path with the locale segment following the `as-needed` routing
 * strategy: default locale (vi) has no prefix, other locales get `/{locale}`.
 * Dùng cho các <Link next/link> trần (không phải Link của next-intl) để tránh
 * trỏ tới URL thiếu locale → 404 khi đang ở /en, /cs.
 * Locale nên là locale của chính bài viết (post.attributes.locale). Nhận
 * `undefined` để callers truyền thẳng giá trị optional — khi đó coi như default
 * (không prefix); theo bất biến i18n của Strapi thì trường hợp này không xảy ra.
 * @param locale - locale của bài (e.g. "vi", "en", "cs")
 * @param path - đường dẫn nội bộ, có hoặc không có "/" đầu (e.g. "my-slug")
 */
export function getLocalizedHref(locale: string | undefined, path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`
  return !locale || locale === routing.defaultLocale ? normalized : `/${locale}${normalized}`
}
